import React from 'react';
import SvgPattern from './svgPattern.js';
import Tooltip from 'shared/components/andtComponents/Tooltip';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import tooltipStyles from 'shared/components/andtComponents/Tooltip.module.scss';
import styles from './customizeLegend.module.scss';

export const CustomizedLegend = ({ payload, hideKeys, specialLegends, dataProperties, info }) => (
  <div className={styles.customizedLegendWrapper}>
    <div className={styles.customizedLegend}>
      {payload?.map((entry, index) => {
        const entryId = `${entry.payload.id ?? index}Legend`;
        return !hideKeys?.includes(entry.dataKey) ? (
          <div key={entryId} className={styles.legendPair} id={entryId}>
            {!specialLegends?.includes(entry.dataKey) ? (
              <svg width="20" height="10" className={styles.legendSymbol}>
                <rect width="20" height="10" fill={entry.color} />
              </svg>
            ) : (
              <div
                className={styles.legendSymbolPattern}
                style={{
                  background: SvgPattern({ color: dataProperties?.[entry.dataKey]?.legendColors || entry.color }),
                }}
              />
            )}
            <Tooltip
              title={dataProperties?.[entry.value]?.displayValue || entry.value}
              classes={{ tooltip: tooltipStyles.whiteTooltip, arrow: tooltipStyles.whiteArrow }}
            >
              <div className={styles.legendLabel}>{dataProperties?.[entry.value]?.displayValue || entry.value}</div>
            </Tooltip>
          </div>
        ) : null;
      })}
      {info ? (
        <>
          <GenerateIcon iconName={ICONS.circleExclamationRegular.name} className={styles.infoIcon} />
          <span className={styles.infoText}>{info}</span>
        </>
      ) : null}
    </div>
  </div>
);
